import React from "react";
import { ImSmile2 } from "react-icons/im";

const Footer = () => {
  return (
    <div className="footerContainer">
      <div><ImSmile2 /> </div><div>DEVELOPED & DESIGNED BY: GABRIELLE ROGERS ©2023</div>
    </div>
  );
};

export default Footer;
